import { DtArray } from '@ow/ditto-core'

const { validation, transformer, filterSpec } = DtArray

export { default as Render } from './render'
export { validation, transformer, filterSpec }
